import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { IAuthState, IUser, IPermissions } from "@/store/modules/auth/types";

type AuthGetterTree = GetterTree<IAuthState, RootState>;

const getPermissions = (state: IAuthState): string[] => {
  const { account } = state;
  if (account && account.permissions) {
    return Object.entries(account.permissions)
      .filter(p => p[1])
      .map(p => {
        switch (p[0]) {
          case "homeRoom":
            return { ...p, [0]: p[0].toLowerCase(), order: 1 };
          default:
            return { ...p, order: null };
        }
      })
      .sort((a, b) => {
        if (a.order && b.order) {
          return a.order > b.order ? 1 : -1;
        }

        return 0;
      })
      .map(p => p[0].toLowerCase());
  }

  return [];
};

export const getters: AuthGetterTree = {
  account(state: IAuthState): IUser | null {
    return state && state.account;
  },

  permissions(state: IAuthState): IPermissions | null {
    return (state.account && state.account.permissions) || null;
  },

  homeRoute(state: IAuthState): string {
    // CCAT
    const host = document.location.host;
    if (
      host === "k5-beta.eprep.link" ||
      host === "ccat-beta.eprep.link" ||
      host === "dev-k5-beta.eprep.link:8080" ||
      host === "dev-ccat-beta.eprep.link:8080"
    ) {
      return "/ccat";
    }
    // end CCAT

    return (
      getPermissions(state)
        .map(p => {
          switch (p) {
            case "homeroom":
              return "/home-room";
            default:
              return "/logout";
          }
        })
        .shift() || ""
    );
  },

  isLogged(state: IAuthState): boolean {
    return !!state.accessToken;
  },

  isOfflineTest(state: IAuthState): boolean {
    const isOnLine = !!(
      state.account &&
      state.account.permissions &&
      state.account.permissions.onlineTesting
    );

    return !isOnLine;
  },

  isOfflineEntryStudent(state: IAuthState): boolean {
    return !!(
      state.account &&
      state.account.permissions &&
      state.account.permissions.offlineEntry === "student"
    );
  },

  isHomeRoomOn(state: IAuthState): boolean {
    const homeRoomOn =
      state.account &&
      state.account.permissions &&
      state.account.permissions.homeRoomOn;

    return !!homeRoomOn;
  },

  hasExamRoom(state: IAuthState, getters: any): boolean {
    return getPermissions(state).some(s => s === "examroom");
  },

  hasHomeRoom(state: IAuthState, getters: any) {
    return getPermissions(state).some(s => s === "homeroom");
  },

  hasToken(state: IAuthState): boolean {
    return !!state.accessToken;
  },
};
